module.exports = __webpack_public_path__ + "static/GlitchlessSonyax4c-8c19345b4ad56bb356bbb8a5ade73564.png";